import { useState, useRef, useEffect} from "react";
import { default as ReactSelect, components, InputAction } from "react-select";

export type Option = {
    value: number | string;
    label: string;
    isDisabled: boolean;
};

const MultiSelect = (props: any) => {
    const [selectInput, setSelectInput] = useState<string>("");
    const isAllSelected = useRef<boolean>(false);
    const selectAllLabel = useRef<string>("Select all");
    const allOption = { value: "*", label: selectAllLabel.current };


    const handleKeyUp = (event: KeyboardEvent) => {
        const { target } = event;
        // here is value is empty then set value false else true, for placeholder position
        if (props?.setTypedValue) {
            if (target instanceof HTMLInputElement) {
                const inputValue = target.value.trim();
                if (inputValue) {
                    props?.setTypedValue(true);
                } else {
                    props?.setTypedValue(false);
                    return;
                }
            }
        }
    };

     // use for keyaddUp
    useEffect(() => {
        let getOtherDoc = document.getElementById("other_docs");
        if(getOtherDoc){
            getOtherDoc.addEventListener('keyup', handleKeyUp);
        }

        return () => {
            let getOtherDoc = document.getElementById("other_docs");
            if(getOtherDoc){
                document.removeEventListener('keyup', handleKeyUp);
            }
        };
         // eslint-disable-next-line
    }, []);

    const filterOptions = (options: Option[], input: string) =>
        options?.filter(({ label }: Option) =>
            label?.toLowerCase().includes(input?.toLowerCase())
        );

    const comparator = (v1: Option, v2: Option) =>
        (v1.value as number) - (v2.value as number);

    let filteredOptions = filterOptions(props.options, selectInput);
    let filteredSelectedOptions = filterOptions(props.value, selectInput);

    const Option = (props: any) => (
        <components.Option {...props}>
            {props.value === "*" &&
                !isAllSelected.current &&
                filteredSelectedOptions?.length > 0 ? (
                <input
                    key={props.value}
                    type="checkbox"
                    ref={(input) => {
                        if (input) input.indeterminate = true;
                    }}
                />
            ) : (
                <input
                    key={props.value}
                    type="checkbox"
                    checked={props.isSelected || isAllSelected.current}
                    onChange={() => { }}
                />
            )}
            <label style={{ marginLeft: "5px", color: 'black' }}>{props.label}</label>
        </components.Option>
    );

    const Input = (props: any) => (
        <>
            {selectInput.length === 0 ? (
                <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
                    {props.children}
                </components.Input>
            ) : (
                <div style={{ border: "1px dotted gray" }}>
                    <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
                        {props.children}
                    </components.Input>
                </div>
            )}
        </>
    );

    const ValueContainer = (props: any) => {

        let selectedValues = props && props.selectProps && props.selectProps.value && props.selectProps.value.length

        let values = `${selectedValues} selected`

        return (
            <>
                {selectedValues > 0 ? (
                    <components.ValueContainer autoFocus={props.selectProps.menuIsOpen} {...props}>
                        <div style={{ color: 'black', fontSize: '.82em' }}>
                            {props.children}
                            {values}

                        </div>
                    </components.ValueContainer>)
                    :
                    (<components.ValueContainer autoFocus={props.selectProps.menuIsOpen} {...props}>
                        {props.children}
                    </components.ValueContainer>
                    )}

            </>
        )

    }

    const customFilterOption = ({ value, label }: Option, input: string) =>
        (value !== "*" && label?.toLowerCase().includes(input?.toLowerCase())) ||
        (value === "*" && filteredOptions?.length > 0);

    const onInputChange = (
        inputValue: string,
        event: { action: InputAction }
    ) => {
        if (event.action === "input-change") setSelectInput(inputValue);
        else if (event.action === "menu-close" && selectInput !== "")
            setSelectInput("");
    };

    const handleChange = (selected: Option[]) => {
        if (
            selected.length > 0 &&
            !isAllSelected.current &&
            (selected[selected.length - 1].value === allOption.value ||
                JSON.stringify(filteredOptions) ===
                JSON.stringify(selected.sort(comparator)))
        )
            return props.onChange(
                [
                    ...(props.value ?? []),
                    ...props.options.filter(
                        ({ label ,isDisabled}: Option) =>
                            label?.toLowerCase().includes(selectInput?.toLowerCase()) && (isDisabled===false || isDisabled===undefined) &&
                            (props.value ?? []).filter((opt: Option) => opt.label === label)
                                .length === 0
                    ),
                ].sort(comparator)
            );
        else if (
            selected.length > 0 &&
            selected[selected.length - 1].value !== allOption.value &&
            JSON.stringify(selected.sort(comparator)) !==
            JSON.stringify(filteredOptions)
        )
            return props.onChange(selected);
        else
            return props.onChange([
                ...props.value?.filter(
                    ({ label, isDisabled }: Option) => {
                        if(isDisabled) { //if option is disabled, is should not be clearable
                            return true
                        } else {
                            return !label?.toLowerCase().includes(selectInput?.toLowerCase())
                        }
                    }
                ),
            ]);
    };

    const customStyles = {
        multiValueLabel: (def: any) => ({
            ...def,
            backgroundColor: "lightgray",
        }),
        multiValueRemove: (def: any) => ({
            ...def,
            backgroundColor: "lightgray",
        }),
        valueContainer: (base: any) => ({
            ...base,
            maxHeight: "65px",
            overflow: "auto",
        }),
        option: (styles: any, { isSelected, isFocused, isDisabled }: any) => {
            return {
                ...styles,
                backgroundColor:
                    isDisabled ? '#f2f2f2' :
                    isSelected && !isFocused
                        ? null
                        : isFocused && !isSelected
                            ? styles.backgroundColor
                            : isFocused && isSelected
                                ? "#DEEBFF"
                                : null,
                color: isSelected ? null : null,
            };
        },
        menu: (def: any) => ({ ...def, zIndex: 9999 }),
        placeholder: (defaultStyles: any) => {
            return {
                ...defaultStyles,
                'fontSize': '0.82em'
            }
        }
    };

    if (props.isSelectAll && props?.options?.length !== 0) {
        isAllSelected.current =
            JSON.stringify(filteredSelectedOptions) ===
            JSON.stringify(filteredOptions);

        if (filteredSelectedOptions?.length > 0) {
            if (filteredSelectedOptions?.length === filteredOptions?.length)
                selectAllLabel.current = `All (${filteredOptions.length}) selected`;
            else
                selectAllLabel.current = `${filteredSelectedOptions?.length} / ${filteredOptions.length} selected`;
        } else selectAllLabel.current = "Select all";

        allOption.label = selectAllLabel.current;

        return (
            <ReactSelect
                {...props}
                inputValue={selectInput}
                onInputChange={onInputChange}
                options={[allOption, ...props.options]}
                onChange={handleChange}
                components={{
                    Input: Input,
                    Option: Option,
                    ValueContainer,
                    ...props.components,
                }}
                placeholder={(props.value && props.value.length) ? "" : props.placeholder}
                filterOption={customFilterOption}
                menuPlacement={'bottom'}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
                tabSelectsValue={false}
                hideSelectedOptions={false}
                controlShouldRenderValue={false}
                // instanceId={useId()}
            />
        );
    }

    return (
        <ReactSelect
            {...props}
            inputValue={selectInput}
            onInputChange={onInputChange}
            filterOption={customFilterOption}
            components={{
                Input: Input,
                ValueContainer,
                ...props.components,
            }}
            placeholder={(props.value && props.value.length) ? "" : props.placeholder}
            menuPlacement={'bottom'}
            hideSelectedOptions={true}
            controlShouldRenderValue={false}
            // instanceId={useId()}
            styles={customStyles}

        />
    );
};

export default MultiSelect;
